import {useContext} from "react"
import { CreateProjetContext } from "./context"

export function useCreateProjetHook() {
    return useContext(CreateProjetContext);
}